<script>
import pfMixin from '../../../../mixins/pfMixin'
export default {
	mixins: [pfMixin],
	components: {
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../PfModal'),
		PfLoader: () => import(/* webpackChunkName: "pf-loader" */ '../PfLoader'),
	},
	props: ['client', 'analysis', 'name'],

	data() {
		return {
			cliente: null,
			datos: {
				notas: ''
			},
			config: {
				events: {
					initialized: function () {
						console.log('initialized')
					}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},
	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'datos', {...newData.datos})
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		removeBank(index) {
			this.datos.pool_bancario.splice(index, 1)
		},

		addBankToPool() {
			this.datos.pool_bancario.push({
				banco: '',
				informacion_cliente_cp: '',
				informacion_cliente_cp_p: '',
				informacion_cliente_lp: '',
				informacion_cliente_lp_p: '',
				otras_empresas_cp: '',
				otras_empresas_cp_p: '',
				otras_empresas_lp: '',
				otras_empresas_lp_p: '',
			})
		},

		addBuro() {
			this.datos.buro_de_credito.push({
				buro_de_credito: '',
				fecha: '',
				clave_de_prevencion: '',
				no_bancos: '',
				mn: '',
				dls_val: '',
				udis_val: '',
				total: '',
				hasta_30_d: '',
				hasta_90_d: '',
				mas_90_d: '',
			})
		}
	}

}
</script>
<template>
<!-- TODO COLUMNAS PENDIENTES EN EL POOL DE BANCOS -->
<!-- TODO FORMATO DE AGRGEGAR REGISTRO AL BURO -->
	<div class="pb-5">
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
	
		<div class="d-flex align-items-center py-3">
			<div class="d-flex align-items-center">
				<h4 class="">Relaciones Bancarias</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
			</div>
			
		</div>

		<div id="accordion_banking" class="pf-accordion  pb-3">
			<div class="card">
				<div class="card-header p-1" id="br_h_1">
					<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" data-target="#br_1" aria-expanded="true" aria-controls="br_1">
						Pool Bancario
					</button>
				</div>

				<div id="br_1" class="collapse show" aria-labelledby="br_h_1" data-parent="#accordion_banking">
					<div class="d-flex flex-wrap pt-5">
						<div class="col-12">
							<div style="overflow-x: auto">
								<table class="table pf-table-th-gray table-bordered">
									<tbody>
										<tr>
											<th class="text-center" colspan="4">CONCENTRACION DE PASIVO BANCARIO:</th>
											<th class="text-center">FECHA:</th>
											<th class="text-center"><input type="date" class="px-1" v-model="datos.pool_bancario_fecha"></th>
											<th class="text-center" colspan="3">(CIFRAS EN MILES)</th>
										</tr>
										<tr>
											<th class="text-center">(CUOTA DE BANQUERO)</th>
											<th class="text-center" colspan="4">INFORMACIÓN DEL CLIENTE</th>
											<th class="text-center" colspan="4">OTRAS EMPRESAS GPO.</th>
										</tr>
										<tr>
											<th class="text-center">BANCO</th>
											<th class="text-center">C.P.</th>
											<th class="text-center">%</th>
											<th class="text-center">L.P</th>
											<th class="text-center">%</th>
											<th class="text-center">C.P.</th>
											<th class="text-center">%</th>
											<th class="text-center">L.P</th>
											<th class="text-center">%</th>
										</tr>
										<tr v-for="(banco, index) in datos.pool_bancario" :key="`pool_banco_${index}`">
											<td>
												<div class="d-flex">
													<button class="btn btn-light p-1 text-primary" @click="removeBank(index)">
														<span class="icon-trash"></span>
													</button>
													<select class="pf-control__input ml-2" style="width: 200px" name="" id="" v-model="banco.banco">
														<option value="">--Seleccione--</option>
														<option value="BBVA MEXICO">BBVA MEXICO</option>      
														<option value="BBVA ABU DHABI (OFI. REP.)">BBVA ABU DHABI (OFI. REP.)</option>
														<option value="BBVA BANCO FRANCÉS">BBVA BANCO FRANCÉS</option>
														<option value="BBVA BEIJING (OFI. RESP.)">BBVA BEIJING (OFI. RESP.)</option>
														<option value="BBVA BRASIL (SUC.)">BBVA BRASIL (SUC.)</option>
														<option value="BBVA CHILE">BBVA CHILE</option>
														<option value="BBVA COLOMBIA">BBVA COLOMBIA</option>
														<option value="BBVA COMPASS BANCHARES INC">BBVA COMPASS BANCHARES INC</option>
														<option value="BBVA CONTINENTAL">BBVA CONTINENTAL</option>      
														<option value="BBVA FRANKFURT (SUC.)">BBVA FRANKFURT (SUC.)</option>      
														<option value="BBVA HONG KONG (SUC.)">BBVA HONG KONG (SUC.)</option>      
														<option value="BBVA IRLANDA">BBVA IRLANDA</option>      
														<option value="Santander">Santander</option>      
														<option value="Scotiabank">Scotiabank</option>      
														<option value="Banamex">Banamex</option>      
														<option value="Inbursa">Inbursa</option>      
														<option value="Multiva">Multiva</option>      
														<option value="HSBC">HSBC</option>      
														<option value="Bancomext">Bancomext</option>      
														<option value="Bank of America">Bank of America</option>      
														<option value="GE capital">GE capital</option>      
														<option value="Banco Do Brasil">Banco Do Brasil</option>      
														<option value="Banco Itau">Banco Itau</option>      
														<option value="IXE Banco">IXE Banco</option>      
														<option value="Inbursa Banco">Inbursa Banco</option>      
														<option value="Banobras">Banobras</option>      
														<option value="Ing Barings USD">Ing Barings USD</option>      
														<option value="HSBC-EXIMBANK">HSBC-EXIMBANK</option>      
														<option value="HSBC/BBVA">HSBC/BBVA</option>      
														<option value="CREDIT AGRICOLE-EXIM BANK">CREDIT AGRICOLE-EXIM BANK</option>      
														<option value="HSBC-EDC">HSBC-EDC</option>      
														<option value="BANK OF NEW YORK">BANK OF NEW YORK</option>      
														<option value="Banorte">Banorte</option>      
														<option value="Bx+">Bx+</option>      
														<option value="Otros">Otros</option>      
													</select>
												</div>
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 150px;" v-model="banco.informacion_cliente_cp">
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 100px;" v-model="banco.informacion_cliente_cp_p">
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 150px;" v-model="banco.informacion_cliente_lp">
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 100px;" v-model="banco.informacion_cliente_lp_p">
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 150px;" v-model="banco.otras_empresas_cp">
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 100px;" v-model="banco.otras_empresas_cp_p">
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 150px;" v-model="banco.otras_empresas_lp">
											</td>
											<td>
												<input type="text" class="pf-control__input text-right" style="width: 100px;" v-model="banco.otras_empresas_lp_p">
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="col-12 py-2">
							<div>
								<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="addBankToPool"> <span class="icon-blank-page"></span> Nuevo Registro</button>
							</div>
						</div>
						<div class="col-12 py-2">
							<table class="table pf-table-th-gray table-bordered" style="width: auto">
								<tr>
									<th>
										CUOTA BANCARIA BBVA % <input type="text" v-model="datos.cuota_bancaria_bbva">
									</th>
								</tr>
							</table>
						</div>
						<div class="col-12 mx-auto py-2">
							<label class="pf-control d-flex">
								<span class="pf-control__label"></span>
								<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
							</label>	
							<quill-editor
							ref="myQuillEditor"
							v-model="datos.comentarios_pool_bancario"
							@change="$parent.updatedForms"
							/>
						</div>	
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="br_h_2">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#br_2" aria-expanded="true" aria-controls="br_2">
						Cesion de Negocio y Rentabilidad
					</button>
				</div>

				<div id="br_2" class="collapse " aria-labelledby="br_h_2" data-parent="#accordion_banking">
					<div class="d-flex flex-wrap pt-5">
						<div class="col-12 mx-auto py-2">
							<label class="pf-control d-flex">
								<span class="pf-control__label text-primary">CESIONES DE NEGOCIO Y RENTABILIDAD</span>
								<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
							</label>	
							<quill-editor
							ref="myQuillEditor"
							v-model="datos.cesiones_de_negocio_y_rentabilidad"
							@change="$parent.updatedForms"
							/>
						</div>	
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="br_h_3">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#br_3" aria-expanded="true" aria-controls="br_3">
						Detalle Riesgo de Tesorería (Productos, importantes, plazos)
					</button>
				</div>

				<div id="br_3" class="collapse" aria-labelledby="br_h_3" data-parent="#accordion_banking">
					<div class="d-flex flex-wrap pt-5">
						<div class="col-12 mx-auto py-2">
							<label class="pf-control d-flex">
								<span class="pf-control__label text-primary"></span>
								<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
							</label>	
							<quill-editor
							ref="myQuillEditor"
							v-model="datos.detalle_riesgos_de_tesoreria"
							@change="$parent.updatedForms"
							/>
						</div>	
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="br_h_4">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#br_4" aria-expanded="true" aria-controls="br_4">
						Información de Buró de Crédito
					</button>
				</div>

				<div id="br_4" class="collapse" aria-labelledby="br_h_4" data-parent="#accordion_banking">
					<div class="d-flex pt-2 flex-wrap">
						<div class="col-12 py-2">
							<div class="ml-auto text-right">
								<button class="btn btn-light btn-sm rounded-0 font-weight-bold"> <span class="icon-refresh"></span> Actualizar</button>
							</div>
						</div>
						<div class="col-12">
							<div style="overflow-x: auto">
								<table class="table pf-table-th-gray table-bordered">
									<tr>
										<th class="text-center" colspan="11">BURÓ DE CRÉDITO</th>
									</tr>
									<tr>
										<th class="text-center" colspan="8">EXPERIENCIA DE PAGO</th>
										<th class="text-center" colspan="3">EN IMPAGO</th>
									</tr>
									<tr>
										<th class="text-center">
											BURÓ DE CRÉDITO
										</th>
										<th class="text-center">
											FECHA
										</th>
										<th class="text-center">
											CLAVE DE PREVENCIÓN
										</th>
										<th class="text-center">
											NO. BANCOS
										</th>
										<th class="text-center">
											M.N.
										</th>
										<th class="text-center">
											DLS. VAL.
										</th>
										<th class="text-center">
											UDIS. VAL
										</th>
										<th class="text-center">
											TOTAL
										</th>
										<th class="text-center">
											HASTA 30 D
										</th>
										<th class="text-center">
											HASTA 90 D
										</th>
										<th class="text-center">
											MAS DE 90 D
										</th>
									</tr>
									<tr v-for="(buro, index) in cliente.datos.buro" :key="`buro_credito_${index}`">
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.buro_de_credito">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.fecha">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.clave_de_prevencion">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.no_bancos">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.mn">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.dls_val">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.udis_val">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.total">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.hasta_30_d">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.hasta_90_d">
										</td>
										<td class="p-1">
											<input type="text" class="pf-control__input " disabled :value="buro.mas_90_d">
										</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="col-12 py-2">
							<div>
								<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="addBuro"> <span class="icon-blank-page"></span> Nuevo Registro</button>
							</div>
						</div>
						<div class="col-12 py-2">
							<label class="pf-control d-flex">
								<span class="pf-control__label text-primary"></span>
								<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
							</label>	
							<quill-editor
							ref="myQuillEditor"
							v-model="datos.comentario_buro_de_credito"
							@change="$parent.updatedForms"
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-header p-1" id="br_h_5">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#br_5" aria-expanded="true" aria-controls="br_5">
						Watch-List/Refinanción/Calificación Contable
					</button>
				</div>

				<div id="br_5" class="collapse" aria-labelledby="br_h_5" data-parent="#accordion_banking">
					<div class="d-flex">
						<div class="col-3">
							<label class="pf-control">
								<span class="pf-control__label text-center">Wacth-List</span>
								<select class="pf-control__input pf-control--block" v-model="datos.watch_list">
									<option value="">--Seleccione--</option>
									<option value="WL 1">WL 1</option>
									<option value="WL 2">WL 2</option>
									<option value="WL 3">WL 3</option>
									<option value="NO">NO</option>
								</select>
							</label>	
						</div>
						<div class="col-3">
							<label class="pf-control">
								<span class="pf-control__label text-center">Refinanciado</span>
								<select class="pf-control__input pf-control--block" v-model="datos.refinanciado">
									<option value="">--Seleccione--</option>
									<option value="NO">NO</option>
									<option value="N/A">N/A</option>
									<option value="SI">SI</option>
								</select>
							</label>	
						</div>
						<div class="col-3">
							<label class="pf-control">
								<span class="pf-control__label text-center">Calificación</span>
								<input class="pf-control__input pf-control--block" type="text" v-model="datos.calificacion">
								<!-- <select class="pf-control__input pf-control--block" v-model="datos.calificacion">
									<option value="">--Seleccione--</option>
									<option value="Normal">Normal</option>
									<option value="Subestándar">Subestándar</option>
									<option value="Dudoso objetivo">Dudoso objetivo</option>
									<option value="Dudoso contable">Dudoso contable</option>
									<option value="Fallido">Fallido</option>
								</select> -->
							</label>	
						</div>
						<div class="col-3">
							<label class="pf-control">
								<span class="pf-control__label text-center">% Provisión</span>
								<input class="pf-control__input pf-control--block" v-model="datos.provision">
							</label>	
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pf-controls-flow">
			<div class="container">
				<div class="d-flex">
					<div class="ml-auto pf-controls-flow__button">
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold"  @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>